import { IRBDItem } from "../../../../models/rbd"
import { IDiagramValues } from "../Diagram"
import finder, { findText, SELECTOR } from "../helper/finder"
import { equipmentIsPipe, equipmentIsPsv, isElement, isParalelTransmission, isRedundantTransmission, isSerialTransmission } from "../helper/validator"
import { diagram } from '../constants'

export function handleElement(current: IRBDItem, prev: IRBDItem): IDiagramValues {
    let parent: number | number[] | undefined

    parent = handleElementParent(prev)

    const color = 
        (equipmentIsPipe(current) && diagram.node.color.pipe) ||
        (equipmentIsPsv(current) && diagram.node.color.psv) ||
        diagram.node.color.etc
    const strokeColor = 
        (equipmentIsPipe(current) && diagram.node.color.border.pipe) ||
        (equipmentIsPsv(current) && diagram.node.color.border.psv) ||
        diagram.node.color.border.etc
    
    return {
        color,
        strokeColor,
        figure: diagram.node.figure.rect,
        key: current.sequence,
        linkColor: diagram.link.color.show,
        text: findText(current),
        width: diagram.node.width.rect,
        containerWidth: diagram.node.width.rect + 2,
        parent: parent,
    }
}

export function handleElementParent(prev: IRBDItem | undefined): number | number[] | undefined {
    let parent: number[] = [];

    if (prev) {
        // ELEMENT
        if (isElement(prev)) {
            parent.push(prev.sequence)
            return parent;

        // SERIAL
        } else if (isSerialTransmission(prev)) {
            let item = finder(prev, SELECTOR.TRANSMISSION_ELEMENTS)
            if (isSerialTransmission(item[item.length - 1])) {
                return handleElementParent(item[item.length - 1])
            } else {
                parent.push(item[item.length - 1].sequence)
                return parent;
            }

        // PARALEL
        } else if (isParalelTransmission(prev)) {
             const elements = finder(prev, SELECTOR.TRANSMISSION_ELEMENTS)

             const parents = elements.map((i: IRBDItem) => {
                return handleElementParent(i)
             })

             parent = parents.flat()
             return parent
        
        // REDUNDANT
        } else if (isRedundantTransmission(prev)) {
            parent.push(prev.sequence)
            return parent
        }
    } else {
        return parent
    }

}
